import React, { lazy } from 'react'
import { FrontUrls } from 'Constants/FrontUrls'
import { LazyRoute } from 'Modules'

const OrderTaskStatsLazy = lazy(() => import('Pages/orderTasks/components/TaskStats/index'))

export const OrderTaskStatsRoutes = [
	<LazyRoute
		exact
		path={FrontUrls.orders_redesign.stats}
		lazyComponent={OrderTaskStatsLazy}
		key={FrontUrls.orders_redesign.stats}
	/>,
]
